(() => {
  const alias=value=>value==='Portfolio'?'Solo':value==='Figma'?'Figma Motion':value;
  function sync(sectionId, selectedVariant, selectedSoftware) {
    document.querySelectorAll('[data-no-quantity-product]').forEach(node=>{
      if(sectionId && String(node.dataset.sectionId)!==String(sectionId)) return;
      const section=document.getElementById('MainProduct-'+node.dataset.sectionId);
      if(!section) return;
      const main=JSON.parse(node.textContent);
      const current=selectedVariant || main.variants.find(v=>String(v.id)===section.querySelector('form[id^="product-form-"] [name=id]')?.value);
      const licenseIndex=main.options.findIndex(n=>n.toLowerCase()==='license');
      const softwareIndex=main.options.findIndex(n=>n.toLowerCase()==='software');
      const license=current?.options?.[licenseIndex];
      const software=selectedSoftware || (softwareIndex>=0 ? current?.options?.[softwareIndex] : section.querySelector('[data-vv-software]')?.dataset.vvSoftware || section.dataset.vvEdition);
      section.querySelectorAll('[data-comp-card]').forEach(card=>{
        const data=JSON.parse(card.querySelector('[data-comp-data]').textContent);
        const li=data.options.findIndex(n=>n.toLowerCase()==='license');
        const si=data.options.findIndex(n=>n.toLowerCase()==='software');
        const matches=data.variants.filter(v=>license!=null && software && li>=0 && alias(v.options[li])===alias(license) && alias(si>=0 ? v.options[si] : data.legacySoftware)===alias(software));
        const variant=matches.length===1 ? matches[0] : null;
        card.hidden=!variant || section.hasAttribute('data-vv-edition-blocked');
        if(!variant) {card.querySelector('[data-comp-link]')?.removeAttribute('href');return;}
        const link=card.querySelector('[data-comp-link]');
        const url=new URL(link.href || card.dataset.productUrl || '/products/'+card.dataset.productHandle,location.origin);
        url.searchParams.set('variant',variant.id);
        const previewThemeId=section.querySelector('variant-radios, variant-selects')?.dataset.previewThemeId;
        if(previewThemeId) url.searchParams.set('preview_theme_id',previewThemeId); else url.searchParams.delete('preview_theme_id');
        link.href=url.toString();
        const label=card.querySelector('.js-comp-variant');
        if(label){label.textContent='License: '+alias(license).replace('Commercial ','');label.hidden=false;}
        const price=card.querySelector('template[data-variant-id="'+variant.id+'"]');
        const target=card.querySelector('.js-comp-price');
        if(price && target)target.replaceChildren(price.content.cloneNode(true));
        const cue=card.querySelector('template[data-comp-cue-variant-id="'+variant.id+'"]');
        const cueTarget=card.querySelector('.js-comp-cue');
        if(cue && cueTarget){cueTarget.textContent=cue.content.textContent.trim();link.setAttribute('aria-label',cueTarget.textContent+' — '+card.dataset.productTitle);}
      });
    });
  }
  document.addEventListener('variant:change',e=>sync(e.detail?.sectionId,e.detail?.variant));
  document.addEventListener('vv:edition-change',e=>sync(e.detail?.sectionId,e.detail?.variant,e.detail?.software));
  document.addEventListener('recommendations:loaded',()=>sync());
  document.addEventListener('shopify:section:load',()=>sync());
  sync();
})();

